import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "I'm a small local business. Is this overkill for me?",
    a: "No — it's actually built for you. Most agencies target enterprise. Vyomex is designed specifically for gyms, consultants, tutors, clinics, and small service businesses where every lead matters and there's no dedicated ops team.",
  },
  {
    q: "How long does setup take?",
    a: "7 days from kickoff. Day 1–2: audit & plan. Day 3–5: build & connect (WhatsApp/Gmail/forms/Sheets). Day 6–7: testing & go-live. We move fast because we've templated the plumbing — only the strategy is bespoke.",
  },
  {
    q: "What tools does it work with?",
    a: "Website forms, Instagram DMs, WhatsApp Business, Gmail, Google Sheets, Calendly, Notion, Airtable, and most CRMs. If you use something else, we'll connect it via Zapier/Make.",
  },
  {
    q: "Do I need to replace my existing tools?",
    a: "Usually not. We build around what you already use. The goal is to plug the leaks, not force you into a new stack.",
  },
  {
    q: "What does it cost?",
    a: "Pricing depends on scope — typically a one-time setup fee + optional monthly optimization retainer. Book a discovery call and we'll give you an exact quote in the call. No hidden fees, no long contracts, 30-day money-back guarantee.",
  },
  {
    q: "What if it doesn't work for my business?",
    a: "30-day money-back guarantee. If the system doesn't deliver measurable lead response improvement in the first 30 days, you get a full refund. We only keep clients we can actually help.",
  },
  {
    q: "Is my customer data safe?",
    a: "Yes. Your data stays in your own Google account, your own CRM, your own Sheets. We only connect the plumbing — we never store or sell your customer data.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="relative py-24 sm:py-32">
      <div className="max-w-4xl mx-auto px-6">
        <div className="mb-12 text-center">
          <p className="text-xs uppercase tracking-[0.25em] text-[#00F0FF] mb-4" data-testid="faq-kicker">FAQ</p>
          <h2 className="font-display text-4xl sm:text-5xl font-medium text-white leading-tight" data-testid="faq-heading">
            Everything you want to know.
          </h2>
          <p className="mt-5 text-white/60 text-lg">Can't find your answer? Drop it in the form below — we'll reply within a day.</p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6 }}
          className="glass-card p-4 md:p-8"
        >
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((item, i) => (
              <AccordionItem
                key={item.q}
                value={`item-${i}`}
                className="border-white/10"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left text-white hover:text-[#00F0FF] hover:no-underline font-display text-lg font-medium py-5">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-white/70 text-base leading-relaxed pb-5">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
